import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import './style.css';
import './themes/devexpress.css';

ReactDOM.render(<App />, document.getElementById('root'));
